import { X } from "lucide-react";
import { Button } from "@mui/material";
import { TailwindModal } from "../../../../components/TailwindModal";

interface ChartTypePasteModalProps {
  open: boolean;
  value: string;
  onChange: (next: string) => void;
  onClose: () => void;
  onCreate: () => void;
  /** Shown under the title when set (e.g. selected chart type label). */
  chartTypeHint?: string | null;
}

export default function ChartTypePasteModal({
  open,
  value,
  onChange,
  onClose,
  onCreate,
  chartTypeHint,
}: ChartTypePasteModalProps) {
  return (
    <TailwindModal isOpen={open} onClose={onClose}>
      <div className="relative mx-auto w-full max-w-[620px] rounded-[28px] border border-[#efeff1] bg-[#f5f5f6] p-5 shadow-xl">
        <button
          type="button"
          onClick={onClose}
          className="absolute right-5 top-5 rounded-md p-1 text-[#444] hover:bg-gray-200"
          aria-label="Close"
        >
          <X size={18} />
        </button>
        <h2 className="pr-8 text-[13px] font-semibold tracking-tight text-[#1f1f1f]">
          Type / Paste your JSON
        </h2>
        {chartTypeHint ? (
          <p className="mt-1 pr-8 text-[12px] text-[#5c5c5f]">{chartTypeHint}</p>
        ) : null}
        <div className="mt-4 rounded-[24px] bg-[#ebebed] p-3">
          <textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Paste your data or start typing..."
            spellCheck={false}
            className="h-[340px] w-full resize-none rounded-[20px] border border-[#dddddf] bg-[#f4f4f6] p-5 font-mono text-[10px] leading-[1.35] text-[#4a4a4d] outline-none placeholder:text-[#6a6a6f]"
          />
        </div>
        <div className="mt-5 flex items-center justify-end gap-3">
          <Button
            variant="text"
            size="small"
            onClick={onClose}
            sx={{
              textTransform: "none",
              minWidth: 0,
              color: "#1f1f1f",
              fontSize: 14,
              fontWeight: 600,
              borderRadius: 999,
              px: 1.5,
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            size="small"
            onClick={onCreate}
            sx={{
              textTransform: "none",
              backgroundColor: "#1f2023",
              borderRadius: 999,
              px: 2.25,
              py: 0.8,
              fontSize: 14,
              fontWeight: 700,
              "&:hover": { backgroundColor: "#131417" },
            }}
          >
            Save chart
          </Button>
        </div>
      </div>
    </TailwindModal>
  );
}
